import { render } from "./DeleteMedicationDialog.vue?vue&type=template&id=b578c562"
import script from "./DeleteMedicationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteMedicationDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__